/*******************************************************************************
 *** MbrAprvMngDetail ** 회원 상세정보 * 회원조회/회원 승인 처리
********************************************************************************/
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import LabelCheckBox from "@/js/common/ui/input/LabelCheckBox";
import SelectBox from "@/js/common/ui/input/SelectBox";
import Util from "@/js/common/Util";
import React from "react";
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import PersonIcon from '@mui/icons-material/Person';
import FeedbackIcon from '@mui/icons-material/Feedback';

interface Props {
    userId: string;
    setViewType: Function;
    setMemberModalOpen: Function;
    setCallTime: Function;
}

const MbrAprvMngDetail = ( {userId, setViewType, setMemberModalOpen, setCallTime}: Props) => {
    const [userNm    , setUserNm    ] = React.useState<string>(""); // 이름
    const [upOgnzCd  , setUpOgnzCd  ] = React.useState<string>(""); // 본부
    const [ognzCd    , setOgnzCd    ] = React.useState<string>(""); // 지부
    const [telno     , setTelno     ] = React.useState<string>(""); // 전화번호
    const [jbpsSeCd  , setJbpsSeCd  ] = React.useState<string>(""); // 직위코드
    const [joinSttsCd, setJoinSttsCd] = React.useState<string>(""); // 가입상태코드
    const [joinSttsNm, setJoinSttsNm] = React.useState<string>(""); // 가입상태명
    const [crtDt     , setCrtDt     ] = React.useState<string>(""); // 가입일자
    const [atrzOpnnCn, setAtrzOpnnCn] = React.useState<string>(""); // 결재의견(반려 사유)

    const [auth01Yn, setAuth01Yn] = React.useState<boolean>(false); // 조합비 관리자
    const [auth02Yn, setAuth02Yn] = React.useState<boolean>(false); // 조합비 결재자
    const [auth03Yn, setAuth03Yn] = React.useState<boolean>(false); // 조합비 조회
    const [auth04Yn, setAuth04Yn] = React.useState<boolean>(false); // 조합원 관리자
    const [auth05Yn, setAuth05Yn] = React.useState<boolean>(false); // 조합원 결재자
    const [auth06Yn, setAuth06Yn] = React.useState<boolean>(false); // 조합원 조회
    const [auth07Yn, setAuth07Yn] = React.useState<boolean>(false); // 본부 관리자
    const [auth08Yn, setAuth08Yn] = React.useState<boolean>(false); // 시스템 관리자

    const [DisabledAuth01, setDisabledAuth01] = React.useState<boolean>(false); // 조합비 관리자 Disabled
    const [DisabledAuth02, setDisabledAuth02] = React.useState<boolean>(false); // 조합비 결재자 Disabled
    const [DisabledAuth03, setDisabledAuth03] = React.useState<boolean>(false); // 조합비 조회 Disabled
    const [DisabledAuth04, setDisabledAuth04] = React.useState<boolean>(false); // 조합원 관리자 Disabled
    const [DisabledAuth05, setDisabledAuth05] = React.useState<boolean>(false); // 조합원 결재자 Disabled
    const [DisabledAuth06, setDisabledAuth06] = React.useState<boolean>(false); // 조합원 조회 Disabled
    const [DisabledAuth07, setDisabledAuth07] = React.useState<boolean>(false); // 본부 관리자 Disabled
    const [DisabledAuth08, setDisabledAuth08] = React.useState<boolean>(false); // 시스템 관리자 Disabled

    const [lockFeeAuthRow, setLockFeeAuthRow] = React.useState<boolean>(false); // 조합비 권한 행 잠금
    const [lockMbrAuthRow, setLockMbrAuthRow] = React.useState<boolean>(false); // 조합원 권한 행 잠금

    const isWithdrawn = joinSttsCd === "04"; // 탈퇴 상태

    // 승인 대상 회원 상세정보 조회
    React.useEffect(() => {
        AppContext.showSpinner();
        Axios.dataAccess({
            url        : "system/mbr/mng/select-mbr-aprv-wtng-dtl.do",
            methodType : "post",
            paramType  : "json",
            paramData  : {
                userId: userId,
            },
            onSuccessFn: (res: any) => {
                setUserNm    (res.result.item.userNm    ); // 이름
                setUpOgnzCd  (res.result.item.upOgnzCd  ); // 본부코드
                setOgnzCd    (res.result.item.ognzCd    ); // 지부코드
                setTelno     (res.result.item.telno     ); // 전화번호
                setJbpsSeCd  (res.result.item.jbpsSeCd  ); // 직위코드
                setJoinSttsCd(res.result.item.joinSttsCd); // 가입상태코드
                setJoinSttsNm(res.result.item.joinSttsNm); // 가입상태명
                setAtrzOpnnCn(res.result.item.atrzOpnnCn); // 결재의견(반려 사유)
                setCrtDt     (res.result.item.crtDt     ); // 가입일자
                setAuth01Yn(res.result.item.auth01Yn === "Y" ? true : false); // 조합비 관리자
                setAuth02Yn(res.result.item.auth02Yn === "Y" ? true : false); // 조합비 결재자
                setAuth03Yn(res.result.item.auth03Yn === "Y" ? true : false); // 조합비 조회
                setAuth04Yn(res.result.item.auth04Yn === "Y" ? true : false); // 조합원 관리자
                setAuth05Yn(res.result.item.auth05Yn === "Y" ? true : false); // 조합원 결재자
                setAuth06Yn(res.result.item.auth06Yn === "Y" ? true : false); // 조합원 조회
                setAuth07Yn(res.result.item.auth07Yn === "Y" ? true : false); // 본부 관리자
                setAuth08Yn(res.result.item.auth08Yn === "Y" ? true : false); // 시스템 관리자

                // 조합비 관리자
                if (res.result.item.auth01Yn === "Y") {
                    setDisabledAuth02(true);
                    setDisabledAuth03(true);
                    if (res.result.item.upOgnzCd === "00") {    // 조합본부
                        setDisabledAuth07(false);
                    }
                }

                // 조합비 결재자
                if (res.result.item.auth02Yn === "Y") {
                    setDisabledAuth01(true);
                    setDisabledAuth03(true);
                    if (res.result.item.auth04Yn !== "Y") { // 조합원 결재자가 아닌 경우
                        setDisabledAuth07(true); // 본부 관리자
                    }
                }
                // 조합원 조회자
                if (res.result.item.auth03Yn === "Y") {
                    setDisabledAuth01(true);
                    setDisabledAuth02(true);
                    if (res.result.item.auth04Yn !== "Y") { // 조합원 결재자가 아닌 경우
                        setDisabledAuth07(true); // 본부 관리자
                    }
                }

                // 조합원 관리자
                if (res.result.item.auth04Yn === "Y") {
                    setDisabledAuth05(true);
                    setDisabledAuth06(true);
                    if (res.result.item.upOgnzCd === "00") {    // 조합본부
                        setDisabledAuth07(false);
                    }
                }

                // 조합원 결재자
                if (res.result.item.auth05Yn === "Y") {
                    setDisabledAuth04(true);
                    setDisabledAuth06(true);
                    if (res.result.item.auth01Yn !== "Y") { // 조합비 결재자가 아닌 경우
                        setDisabledAuth07(true); // 본부관리자
                    }
                }
                // 조합원 조회자
                if (res.result.item.auth06Yn === "Y") {
                    setDisabledAuth04(true);
                    setDisabledAuth05(true);
                    if (res.result.item.auth01Yn !== "Y") { // 조합비 결재자가 아닌 경우
                        setDisabledAuth07(true); // 본부관리자
                    }
                }

                // 조합원 관리자 and 조합비 관리자가 아닌 경우 또는 조합본부가 아닌 경우
                if ((res.result.item.auth01Yn === "N" && res.result.item.auth04Yn === "N") || res.result.item.upOgnzCd !== "00" ) {
                    setDisabledAuth07(true); // 본부관리자
                }
                // 시스템관리자
                setDisabledAuth08(true);

                AppContext.hideSpinner();
            },
        });
    }, [userId]);

    // 사용승인
    function goUserApproval() {
        const authValues = [auth01Yn, auth02Yn, auth03Yn, auth04Yn, auth05Yn, auth06Yn, auth07Yn, auth08Yn];
        const isAllFalse = authValues.every(value => value === false);

        if (isAllFalse) {
            AppContext.openAlert({
                title: "회원 권한 확인",
                msg: "회원의 권한을 선택하십시오.",
                icon: "warning"
            });
            return;
        }

        checkJbpsDuplicate(jbpsSeCd, () => {
            AppContext.openAlert({
                title: "회원가입 승인",
                msg: userNm + " 회원님의 회원가입을 승인하시겠습니까?",
                icon: "check",
                confirmText: "승인",
                handleConfirm: () => {
                    AppContext.showSpinner();
                    Axios.dataAccess({
                        url: "system/mbr/mng/process-mbr-aprv-wtng-atrz.do",
                        methodType: "post",
                        paramType: "json",
                        paramData: {
                            userId  : userId,
                            upOgnzCd: upOgnzCd, // 본부조직코드
                            ognzCd  : ognzCd  , // 지부조직코드
                            jbpsSeCd: jbpsSeCd, // 직위구분코드
                            auth01Yn: auth01Yn ? "Y" : "N", // 조합비 관리자
                            auth02Yn: auth02Yn ? "Y" : "N", // 조합비 결재자
                            auth03Yn: auth03Yn ? "Y" : "N", // 조합비 조회
                            auth04Yn: auth04Yn ? "Y" : "N", // 조합원 관리자
                            auth05Yn: auth05Yn ? "Y" : "N", // 조합원 결재자
                            auth06Yn: auth06Yn ? "Y" : "N", // 조합원 조회
                            auth07Yn: auth07Yn ? "Y" : "N", // 본부 관리자
                            auth08Yn: auth08Yn ? "Y" : "N", // 시스템 관리자
                        },
                        onSuccessFn: (res: any) => {
                            setCallTime(new Date());
                            setMemberModalOpen(false);
                            AppContext.hideSpinner();
                            AppContext.openAlert({
                                title: "사용승인 완료",
                                msg: userNm + " 회원님의 회원가입이 승인되었습니다.",
                                icon: "check"
                            });
                        }
                    });
                }
            });
        });
    }

    // 회원 직위 중복 확인
    function checkJbpsDuplicate(checkJbpsSeCd: string, successCallback: Function, isChange: boolean = false) {

        if (Util.isEmpty(checkJbpsSeCd)) {
            if (isChange) {
                successCallback();
                return;
            }

            AppContext.openAlert({
                title: "직위 확인",
                msg: "회원의 직위를 선택하십시오.",
                icon: "warning"
            });
            return;
        }

        // 사무원(11)은 중복 허용
        if (checkJbpsSeCd === "11") {
            successCallback();
            return;
        }

        Axios.dataAccess({
            url        : "system/mbr/mng/select-mbr-jbps-dup-cnt.do",
            methodType : "post",
            paramType  : "json",
            paramData  : {
                userId  : userId,
                ognzCd  : ognzCd,
                jbpsSeCd: checkJbpsSeCd,
            },
            onSuccessFn: (res: any) => {
                if (res.result.cnt > 0) {
                    AppContext.openAlert({
                        title: "직위 선택 불가",
                        msg: `${Util.getValToCode("JBPS_SE_CD", checkJbpsSeCd)} 직위는 해당 소속에서 이미 사용 중입니다.`,
                        icon: "warning"
                    });
                    return;
                }

                successCallback();
            },
        });
    }

    // 비밀번호 초기화
    function resetUserPassword() {
        AppContext.openAlert({
            title: "비밀번호 초기화",
            msg: userNm + " 회원님의 비밀번호를 초기화하시겠습니까?",
            icon: "check",
            confirmText: "초기화",
            handleConfirm: () => {
                AppContext.showSpinner();
                Axios.dataAccess({
                    url: "system/mbr/mng/process-pswd-init.do",
                    methodType: "post",
                    paramType: "json",
                    paramData: {
                        userId: userId,
                    },
                    onSuccessFn: () => {
                        setCallTime(new Date());
                        setMemberModalOpen(false);
                        AppContext.hideSpinner();
                        AppContext.openAlert({
                            title: "비밀번호 초기화 완료",
                            msg: userNm + " 회원님의 비밀번호가 초기화되었습니다.",
                            icon: "check"
                        });
                        return;
                    }
                });
            }
        });
    }

    // 사용정지
    function stopUser() {
        if (lockMbrAuthRow) {
            AppContext.openAlert({
                title: "사용정지 불가",
                msg: "이 회원은 조합원 결재라인로 등록되어 있어 사용정지할 수 없습니다.",
                icon: "warning"
            });
            return;
        }
        if (lockFeeAuthRow) {
            AppContext.openAlert({
                title: "사용정지 불가",
                msg: "이 회원은 조합비 결재라인로 등록되어 있어 사용정지할 수 없습니다.",
                icon: "warning"
            });
            return;
        }
        AppContext.openAlert({
            title: "회원 사용정지",
            msg: userNm + " 회원님을 사용정지 처리하시겠습니까?",
            icon: "check",
            confirmText: "사용정지",
            handleConfirm: () => {
                AppContext.showSpinner();
                Axios.dataAccess({
                    url: "system/mbr/mng/process-mbr-use-stop.do",
                    methodType: "post",
                    paramType: "json",
                    paramData: {
                        userId: userId,
                        joinSttsCd: joinSttsCd, // 회원상태코드
                    },
                    onSuccessFn: (res: any) => {
                        if (res.result.cnt === 1) {
                            setCallTime(new Date());
                            setMemberModalOpen(false);
                            AppContext.hideSpinner();
                            AppContext.openAlert({
                                title: "사용정지 완료",
                                msg: userNm + " 회원님이 사용정지 처리되었습니다.",
                                icon: "check"
                            });
                            return;
                        } else {
                            setMemberModalOpen(false);
                            AppContext.hideSpinner();
                            AppContext.openAlert({
                                title: "회원 사용정지 안내",
                                msg: res.result.error_msg,
                                icon: "check"
                            });
                            return;
                        }
                    }
                });
            }
        });
    }

    function withdrawUser() {
        if (lockMbrAuthRow) {
            AppContext.openAlert({
                title: "탈퇴 불가",
                msg: "해당 회원은 조합원 결재선으로 등록되어 있어 탈퇴 처리할 수 없습니다.",
                icon: "warning"
            });
            return;
        }
        if (lockFeeAuthRow) {
            AppContext.openAlert({
                title: "탈퇴 불가",
                msg: "해당 회원은 조합비 결재선으로 등록되어 있어 탈퇴 처리할 수 없습니다.",
                icon: "warning"
            });
            return;
        }
        AppContext.openAlert({
            title: "회원 탈퇴",
            msg: userNm + " 회원님을 탈퇴 처리하시겠습니까?",
            icon: "check",
            confirmText: "탈퇴",
            handleConfirm: () => {
                AppContext.showSpinner();
                Axios.dataAccess({
                    url: "system/mbr/mng/process-mbr-withdraw.do",
                    methodType: "post",
                    paramType: "json",
                    paramData: {
                        userId: userId,
                        joinSttsCd: joinSttsCd,
                    },
                    onSuccessFn: (res: any) => {
                        if (res.result.cnt === 1) {
                            setCallTime(new Date());
                            setMemberModalOpen(false);
                            AppContext.hideSpinner();
                            AppContext.openAlert({
                                title: "탈퇴 완료",
                                msg: userNm + " 회원님이 탈퇴 처리되었습니다.",
                                icon: "check"
                            });
                            return;
                        } else {
                            setMemberModalOpen(false);
                            AppContext.hideSpinner();
                            AppContext.openAlert({
                                title: "회원 탈퇴 안내",
                                msg: res.result.error_msg,
                                icon: "check"
                            });
                            return;
                        }
                    }
                });
            }
        });
    }

    // 회원정보 수정
    function saveUserInfo() {

        checkJbpsDuplicate(jbpsSeCd, () => {
            AppContext.openAlert({
                title: "회원정보 수정",
                msg: userNm + " 회원님의 회원정보를 수정하시겠습니까?",
                icon: "check",
                confirmText: "정보 수정",
                handleConfirm: () => {
                    AppContext.showSpinner();
                    Axios.dataAccess({
                        url: "system/mbr/mng/save-mbr.do",
                        methodType: "post",
                        paramType: "json",
                        paramData: {
                            userId: userId,
                            jbpsSeCd: jbpsSeCd, // 직위구분코드
                            auth01Yn: auth01Yn ? "Y" : "N", // 조합비 관리자
                            auth02Yn: auth02Yn ? "Y" : "N", // 조합비 결재자
                            auth03Yn: auth03Yn ? "Y" : "N", // 조합비 조회
                            auth04Yn: auth04Yn ? "Y" : "N", // 조합원 관리자
                            auth05Yn: auth05Yn ? "Y" : "N", // 조합원 결재자
                            auth06Yn: auth06Yn ? "Y" : "N", // 조합원 조회
                            auth07Yn: auth07Yn ? "Y" : "N", // 본부 관리자
                            auth08Yn: auth08Yn ? "Y" : "N", // 시스템 관리자
                        },
                        onSuccessFn: () => {
                            setCallTime(new Date());
                            setMemberModalOpen(false);
                            AppContext.hideSpinner();
                            AppContext.openAlert({
                                title: "회원정보 수정 완료",
                                msg: userNm + " 회원님의 회원정보를 수정하였습니다.",
                                icon: "check"
                            });
                            return;
                        }
                    });
                }
            });
        });
    }

    React.useEffect(() => {  // 결재자 라인 등록 권한 여부 체크
        if (!userId) return;
        if (!ognzCd) return;

        AppContext.showSpinner();
        Axios.dataAccess({
            url        : "system/sys/aprvr/select-aprvr-list.do",
            methodType : "post",
            paramType  : "json",
            paramData  : {
                orgCd  : ognzCd,
                atrzSeCd: "01",
            },
            onSuccessFn: (res1: any) => {
                const foundFee = res1.result.list.some((r: any) => r.picUserId === userId);

                Axios.dataAccess({
                    url        : "system/sys/aprvr/select-aprvr-list.do",
                    methodType : "post",
                    paramType  : "json",
                    paramData  : {
                        orgCd  : ognzCd,
                        atrzSeCd: "02",
                    },
                    onSuccessFn: (res2: any) => {
                        const foundMbr = res2.result.list.some((r: any) => r.picUserId === userId);

                        setLockFeeAuthRow(foundFee);
                        setLockMbrAuthRow(foundMbr);

                        AppContext.hideSpinner();
                    },
                });
            },
        });
    }, [userId, ognzCd]);

    return (
        <div className="w600 bsBdb mxw90vw">
            <div className="p15 bd1d9d9d9 bdrd5 bgcWhite bsBdb">
                <div className="csP dpInBlock">
                    <div className="w120 h36 dpFlx aiC jcL h30">
                        <PersonIcon style={{ fontSize: 28, color: '#2882B7' }} />
                        <span className="Pretendard-Bold fs16 fc222222 ls075 taU fwB ml5">회원정보</span>
                    </div>
                </div>
                <div className="w100p">
                    <table className="w100p" style={{border: "1px solid #CECECE", borderCollapse: "collapse"}}>
                        <colgroup>
                            <col className='w15p'></col>
                            <col className='w35p'></col>
                            <col className='w15p'></col>
                            <col className='w35p'></col>
                        </colgroup>
                        <tbody>
                        <tr style={{height: "30px"}} >
                            <td className="pl10"><p className="fw700 fm-c fs14 fc2c3e50 taC">아이디</p></td>
                            <td>
                                <div className="dpFlx aiC jcC w180 bd1 h30 bdrd5 bdcDDDDDD bgcF1F8FF">
                                    <p className="fw700 fm-c fs14 fc2B2B2B taC">{userId}</p>
                                </div>
                            </td>
                            <td className="pl20"><p className="fw700 fm-c fs14 fc2c3e50 taC">이름</p></td>
                            <td>
                                <div className="dpFlx aiC jcC w180 bd1 h30 bdrd5 bdcDDDDDD bgcF1F8FF">
                                    <p className="fw700 fm-c fs14 fc2B2B2B taC">{userNm}</p>
                                </div>
                            </td>
                        </tr>
                        <tr style={{height: "30px"}} >
                            <td className="pl10"><p className="fw700 fm-c fs14 fc2c3e50 taC">본부</p></td>
                            <td>
                                <SelectBox value={upOgnzCd}
                                    width={180} height={36}
                                    fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                                    borderColor="#ddd" borderOnColor="#222" borderRadius={5}
                                    paddingRight={8}
                                    codeArray={[{ code: "", name: "선택" }].concat(Util.getUpOrgCodeArray("01"))}
                                    onChangeFunc={(data: string) => setUpOgnzCd(data)}
                                    background={(joinSttsCd === "02" || joinSttsCd === "04" || joinSttsCd === "05") ? "#F1F8FF" : "#fff"}
                                    disabled={(joinSttsCd === "02" || joinSttsCd === "04" || joinSttsCd === "05") ? true : false}
                                />
                            </td>
                            <td className="pl20"><p className="fw700 fm-c fs14 fc2c3e50 taC">지부</p></td>
                            <td>
                                <SelectBox value={ognzCd}
                                    width={180} height={36}
                                    fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                                    borderColor="#ddd" borderOnColor="#222" borderRadius={5}
                                    paddingRight={8}
                                    codeArray={[{ code: "", name: "선택" }].concat(Util.getDownOrgCodeArray(upOgnzCd))}
                                    onChangeFunc={(data: string) => setOgnzCd(data)}
                                    background={(joinSttsCd === "02" || joinSttsCd === "04" || joinSttsCd === "05") ? "#F1F8FF" : "#fff"}
                                    disabled={(joinSttsCd === "02" || joinSttsCd === "04" || joinSttsCd === "05") ? true : false}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td className="pl10"><p className="fw700 fm-c fs14 fc2c3e50 taC">전화번호</p></td>
                            <td>
                                <div className="dpFlx aiC jcC w180 bd1 h30 bdrd5 bdcDDDDDD bgcF1F8FF">
                                    <p className="fw700 fm-c fs14 fc2B2B2B taC">{Util.setPhoneNum(telno)}</p>
                                </div>
                            </td>
                            <td className="pl20"><p className="fw700 fm-c fs14 fc2c3e50 taC">직위</p></td>
                            <td>
                                <SelectBox value={jbpsSeCd}
                                    width={180} height={36}
                                    fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                                    borderColor="#ddd" borderOnColor="#222" borderRadius={5}
                                    background={joinSttsCd === "04" ? "#F1F8FF" : "#fff"}
                                    disabled={joinSttsCd === "04" ? true : false} paddingRight={8}
                                    codeArray={[{ code: "", name: "선택" }].concat(Util.getCodeArray("JBPS_SE_CD"))}
                                    onChangeFunc={(data: string) => {
                                        checkJbpsDuplicate(data, () => {
                                            setJbpsSeCd(data);
                                        }, true);
                                    }}
                                    placeholder="직위를 선택하세요"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td className="pl10"><p className="fw700 fm-c fs14 fc2c3e50 taC">가입일자</p></td>
                            <td>
                                <div className="dpFlx aiC jcC w180 bd1 h30 bdrd5 bdcDDDDDD bgcF1F8FF">
                                    <p className="fw700 fm-c fs14 fc2B2B2B taC">{crtDt}</p>
                                </div>
                            </td>
                            <td className="pl20"><p className="fw700 fm-c fs14 fc2c3e50 taC">회원상태</p></td>
                            <td>
                                <div className="dpFlx aiC jcC w180 bd1 h30 bdrd5 bdcDDDDDD bgcF1F8FF">
                                    <p className="fw700 fm-c fs14 fc2B2B2B taC">{joinSttsNm}</p>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                {/* 권한 */}
                <div className="csP dpInBlock mt15">
                    <div className="w120 h36 dpFlx aiC jcL h30">
                        <GroupAddIcon style={{ fontSize: 28, color: '#2882B7' }} />
                        <span className="Pretendard-Bold fs16 fc222222 ls075 taU fwB ml5">회원 권한</span>
                    </div>
                </div>

                <div className="w100p">
                    <table className="w100p h110" style={{border: "1px solid #CECECE", borderCollapse: "collapse"}}>
                        <colgroup>
                            <col className='w35p'></col>
                            <col className='w35p'></col>
                            <col className='w30p'></col>
                        </colgroup>
                        <tbody>
                            <tr style={{height: "30px", borderBottom: "1px solid #CECECE"}}>
                                {/* 조합비 관리자 */}
                                <td className="pl20">
                                    <div className='dpFlx'>
                                        <LabelCheckBox
                                            checked={auth01Yn}
                                            onChange={() => {
                                                if (!auth01Yn) {
                                                    setDisabledAuth02(true);
                                                    setDisabledAuth03(true);
                                                    if (upOgnzCd === "00") {
                                                        setDisabledAuth07(false); // 본부인 경우 본부관리자 선택 가능
                                                    }
                                                } else {
                                                    setDisabledAuth02(false);
                                                    setDisabledAuth03(false);
                                                    if (!auth04Yn) { // 조합원 관리자가 아닌 경우
                                                        setDisabledAuth07(true); // 본부관리자 선택 불가
                                                        setAuth07Yn(false); // 본부관리자 초기화
                                                    }
                                                }
                                                setAuth01Yn(!auth01Yn)
                                            }}
                                            buttonColor='#2882B7'
                                            labelText='조합비 관리자'
                                            borderColor='#929191'
                                            borderOnColor='#454545'
                                            color='#666'
                                            textClassName='Pretendard-SemiBold fs15 ls08 ml5'
                                            textStyle={{ fontWeight: auth01Yn ? "bold" : "400" }}
                                            disabled={isWithdrawn || DisabledAuth01}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='dpFlx'>
                                        <LabelCheckBox
                                            checked={auth02Yn}
                                            onChange={() => {
                                                if (lockFeeAuthRow) {
                                                    AppContext.openAlert({
                                                        title: "권한 변경 불가",
                                                        msg: "이 회원은 조합비 결재자로 등록되어 있어 조합비 권한을 변경할 수 없습니다.",
                                                        icon: "warning"
                                                    });
                                                    return;
                                                }
                                                if (!auth02Yn) {
                                                    setDisabledAuth01(true);
                                                    setDisabledAuth03(true);
                                                } else {
                                                    setDisabledAuth01(false);
                                                    setDisabledAuth03(false);
                                                }
                                                setAuth02Yn(!auth02Yn);
                                            }}
                                            buttonColor='#2882B7'
                                            labelText='조합비 결재자'
                                            borderColor='#929191'
                                            borderOnColor='#454545'
                                            color='#666'
                                            textClassName='Pretendard-SemiBold fs15 ls08 ml5'
                                            textStyle={{ fontWeight: auth02Yn ? "bold" : "400" }}
                                            disabled={isWithdrawn || DisabledAuth02}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='dpFlx'>
                                        <LabelCheckBox
                                            checked={auth03Yn}
                                            onChange={() => {
                                                if (!auth03Yn) {
                                                    setDisabledAuth01(true);
                                                    setDisabledAuth02(true);
                                                } else {
                                                    setDisabledAuth01(false);
                                                    setDisabledAuth02(false);
                                                }
                                                setAuth03Yn(!auth03Yn)
                                            }}
                                            buttonColor='#2882B7'
                                            labelText='조합비 조회자'
                                            borderColor='#929191'
                                            borderOnColor='#454545'
                                            color='#666'
                                            textClassName='Pretendard-SemiBold fs15 ls08 ml5'
                                            textStyle={{ fontWeight: auth03Yn ? "bold" : "400" }}
                                            disabled={isWithdrawn || DisabledAuth03}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr style={{height: "30px", borderBottom: "1px solid #CECECE", backgroundColor: "#F9F8F9"}}>
                                {/* 조합원 관리자 */}
                                <td className="pl20">
                                    <div className='dpFlx'>
                                        <LabelCheckBox
                                            checked={auth04Yn}
                                            onChange={() => {
                                                if (!auth04Yn) {
                                                    setDisabledAuth05(true);
                                                    setDisabledAuth06(true);
                                                    if (upOgnzCd === "00") {
                                                        setDisabledAuth07(false); // 본부인 경우 본부관리자 선택 가능
                                                    }
                                                } else {
                                                    setDisabledAuth05(false);
                                                    setDisabledAuth06(false);
                                                    if (!auth01Yn) { // 조합비 관리자가 아닌 경우
                                                        setDisabledAuth07(true); // 본부관리자 선택 불가
                                                        setAuth07Yn(false); // 본부관리자 초기화
                                                    }
                                                }
                                                setAuth04Yn(!auth04Yn)
                                            }}
                                            buttonColor='#2882B7'
                                            labelText='조합원 관리자'
                                            borderColor='#929191'
                                            borderOnColor='#454545'
                                            color='#666'
                                            textClassName='Pretendard-SemiBold fs15 ls08 ml5'
                                            textStyle={{ fontWeight: auth04Yn ? "bold" : "400" }}
                                            disabled={isWithdrawn || DisabledAuth04}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='dpFlx'>
                                        <LabelCheckBox
                                            checked={auth05Yn}
                                            onChange={() => {
                                                if (lockMbrAuthRow) {
                                                    AppContext.openAlert({
                                                        title: "권한 변경 불가",
                                                        msg: "이 회원은 조합원 결재라인로 등록되어 있어 조합원 권한을 변경할 수 없습니다.",
                                                        icon: "warning"
                                                    });
                                                    return;
                                                }
                                                if (!auth05Yn) {
                                                    setDisabledAuth04(true);
                                                    setDisabledAuth06(true);
                                                } else {
                                                    setDisabledAuth04(false);
                                                    setDisabledAuth06(false);
                                                }
                                                setAuth05Yn(!auth05Yn)
                                            }}
                                            buttonColor='#2882B7'
                                            labelText='조합원 결재자'
                                            borderColor='#929191'
                                            borderOnColor='#454545'
                                            color='#666'
                                            textClassName='Pretendard-SemiBold fs15 ls08 ml5'
                                            textStyle={{ fontWeight: auth05Yn ? "bold" : "400" }}
                                            disabled={isWithdrawn || DisabledAuth05}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='dpFlx'>
                                        <LabelCheckBox
                                            checked={auth06Yn}
                                            onChange={() => {
                                                if (!auth06Yn) {
                                                    setDisabledAuth04(true);
                                                    setDisabledAuth05(true);
                                                } else {
                                                    setDisabledAuth04(false);
                                                    setDisabledAuth05(false);
                                                }
                                                setAuth06Yn(!auth06Yn)
                                            }}
                                            buttonColor='#2882B7'
                                            labelText='조합원 조회자'
                                            borderColor='#929191'
                                            borderOnColor='#454545'
                                            color='#666'
                                            textClassName='Pretendard-SemiBold fs15 ls08 ml5'
                                            textStyle={{ fontWeight: auth06Yn ? "bold" : "400" }}
                                            disabled={isWithdrawn || DisabledAuth06}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr style={{height: "30px"}}>
                                <td className="pl20">
                                    <div className='dpFlx'>
                                        <LabelCheckBox
                                            checked={auth07Yn}
                                            onChange={() => setAuth07Yn(!auth07Yn)}
                                            buttonColor='#2882B7'
                                            labelText='본부 관리자'
                                            borderColor='#929191'
                                            borderOnColor='#454545'
                                            color='#666'
                                            textClassName='Pretendard-SemiBold fs15 ls08 ml5'
                                            textStyle={{ fontWeight: auth07Yn ? "bold" : "400" }}
                                            disabled={isWithdrawn || DisabledAuth07}
                                        />
                                    </div>
                                </td>
                                {auth08Yn && (
                                    <td>
                                        <div className='dpFlx'>
                                            <LabelCheckBox
                                                checked={auth08Yn}
                                                onChange={() => setAuth08Yn(!auth08Yn)}
                                                buttonColor='#2882B7'
                                                labelText='시스템 관리자'
                                                borderColor='#929191'
                                                borderOnColor='#454545'
                                                color='#666'
                                                textClassName='Pretendard-SemiBold fs15 ls08 ml5'
                                                textStyle={{ fontWeight: auth08Yn ? "bold" : "400" }}
                                                disabled={isWithdrawn || DisabledAuth08}
                                            />
                                        </div>
                                    </td>
                                )}
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* 반려 사유 표시 */}
                {joinSttsCd === "03" &&
                <>
                    <div className="csP dpInBlock mt15">
                        <div className="w120 h36 dpFlx aiC jcL h30">
                            <FeedbackIcon style={{ fontSize: 25, color: '#2882B7' }} />
                            <span className="Pretendard-Bold fs16 fc222222 ls075 taU fwB ml5">반려 사유</span>
                        </div>
                    </div>
                    <div className="dpFlx aiFs">
                        <div className="flxg1 bsBdb">
                            <textarea
                                value={atrzOpnnCn}
                                className="w100p h100 bsBdb p10 bd1 bdcDFDFDF bdrd2 fm-c fs14 fc333333 ls1 bgcWhite rszN"
                                maxLength={2000}
                                placeholder="반려 사유를 상세히 입력해주세요."
                                onChange={(e) => setAtrzOpnnCn(e.target.value)}
                                readOnly={true}
                            />
                        </div>
                    </div>
                </>
                }
            </div>


            {/* 가입신청 & 반려 상태 */}
            {(joinSttsCd === "01" || joinSttsCd === "03") && (
                <div className='w100p dpFlx aiC jcSb mt20 pb10'>
                    <div className="h40 dpFlx">
                        <div className="w100 aiC jcC bdrd5 bdBox csP dpFlx " style={{backgroundColor: "#bdc3c7"}} onClick={() => setMemberModalOpen(false)}>
                            <span className="fm-b fs15 fc222222">취소</span>
                        </div>
                    </div>
                    <div className="h40 dpFlx">
                        <div className="w100 aiC jcC bdrd5 bdBox csP dpFlx" style={{backgroundColor: "#dc3545"}} onClick={() => setViewType("R")}>
                            <span className="fm-b fs16 fcWhite">반려</span>
                        </div>
                        <div className="w120 aiC jcC bdrd5 bdBox csP dpFlx ml10" style={{backgroundColor: "#007bff"}} onClick={goUserApproval}>
                            <span className="fm-b fs16 fcWhite">사용승인</span>
                        </div>
                    </div>
                </div>
            )}

            {/* 사용승인, 사용정지 */}
            {(joinSttsCd === "02" || joinSttsCd === "05") && (
                <div className='w100p dpFlx aiC jcSb mt20 pb10'>
                    <div className="h40 dpFlx">
                        <div className="w100 aiC jcC bdrd5 bdBox csP dpFlx" style={{backgroundColor: "#bdc3c7"}} onClick={() => setMemberModalOpen(false)}>
                            <span className="fm-b fs15 fc222222">취소</span>
                        </div>
                        <div className="w100 aiC jcC bdrd5 bdBox csP dpFlx ml10" style={{backgroundColor: "#17a2b8"}} onClick={stopUser}>
                            <span className="fm-b fs16 fcWhite">사용정지</span>
                        </div>
                        <div className="w100 aiC jcC bdrd5 bdBox csP dpFlx ml10" style={{backgroundColor: "#dc3545"}} onClick={withdrawUser}>
                            <span className="fm-b fs16 fcWhite">탈퇴처리</span>
                        </div>
                    </div>
                    <div className="h40 dpFlx">
                        <div className="w130 aiC jcC bdrd5 bdBox csP dpFlx" style={{backgroundColor: "#6c757d"}} onClick={resetUserPassword}>
                            <span className="fm-b fs15 fcWhite">비밀번호 초기화</span>
                        </div>
                        <div className="w100 aiC jcC bdrd5 bdBox csP dpFlx ml10" style={{backgroundColor: "#007bff"}} onClick={saveUserInfo}>
                            <span className="fm-b fs16 fcWhite">저장</span>
                        </div>
                    </div>
                </div>
            )}
            {/* 탈퇴 상태 */}
            {joinSttsCd === "04" && (
                <div className='w100p dpFlx aiC jcC mt20 pb10'>
                    <div className="h40 dpFlx">
                        <div
                            className="w100 aiC jcC bdrd5 bdBox csP dpFlx"
                            style={{ backgroundColor: "#bdc3c7" }}
                            onClick={() => setMemberModalOpen(false)}
                        >
                            <span className="fm-b fs15 fc222222">닫기</span>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default MbrAprvMngDetail;